import { unitConstants } from '../constants/unitConstants';

const initialState = {
  units: [],
  dialog: false,
  selectedUnit: {},
};

export default function unit(state = initialState, action) {
  switch (action.type) {
    case unitConstants.GETALL_REQUEST:
      return {
        ...state,
        requesting: true,
      };
    case unitConstants.GETALL_SUCCESS:
      return {
        ...state,
        requesting: false,
        moduleId: action.moduleId,
        units: action.units,
      };
    case unitConstants.GET_TRACKER_REQUEST:
      return {
        ...state,
        requestingTracker: true,
      };
    case unitConstants.GET_TRACKER_SUCCESS:
      return {
        ...state,
        requestingTracker: false,
        tracker: action.time,
      };
    case unitConstants.GET_TRACKER_FAILURE:
      return {
        ...state,
        requestingTracker: false,
      };
    case unitConstants.SET_SELECTED_UNIT:
      return {
        ...state,
        selectedUnit: action.selectedUnit,
      };
    case unitConstants.UNSET_SELECTED_UNIT:
      return {
        ...state,
        selectedUnit: {},
      };
    case unitConstants.TOGGLE_DIALOG:
      return {
        ...state,
        dialog: action.open,
      };
    case unitConstants.GETALL_FAILURE:
      return initialState;
    case unitConstants.UNLOAD_UNITS:
      return {
        ...state,
        units: [],
      };
    case unitConstants.SET_ALL_UNITS_DONE:
      return {
        ...state,
        allUnitsDone: action.set,
      };
    default:
      return state;
  }
}
